@if (status(); as status) {
  <qaroni-title-status-chip
    [status]="status | absenceEmployeeStatus"
    [bgClassColorName]="bgClassColorName"
    matTooltipText="Estado de la ausencia"
    i18n-matTooltipText />
}
